import * as React from "react";

import { Portal, UsePortalDropzone } from "../../Common";

import { ReactCheckout2022Route, useReactCheckout2022Router } from "../providers";

export const HeaderDeliveryTouchpointPortal: React.FunctionComponent = (props) => {
  const { currentRoute } = useReactCheckout2022Router();
  if (currentRoute === ReactCheckout2022Route.payment) {
    return (
      <Portal
        selector={`
      .legacy-magento-checkout-container 
      > .legacy-magento-checkout-container-page-contents-container
      > .legacy-magento-checkout-container-direct-container
    `}
        dropzone={UsePortalDropzone.BeforeFirstChild}
        dontCreateRootElementWhenNone={true}
        portalStagingNodeClassName="legacy-magento-checkout-container--portal-header-delivery-touchpoint"
      >
        {props.children || []}
      </Portal>
    );
  }
  return <React.Fragment>{props.children || []}</React.Fragment>;
};
